// @flow
import { Avatar, Card, CardContent, CardHeader, Grid, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Link as LinkIcon, Refresh as RefreshIcon, VideoLibrary as VideoIcon } from '@material-ui/icons';
import { Skeleton } from '@material-ui/lab';
import { useSnackbar } from 'notistack';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import routes from '../routes';
import Layout from '../component/Layout';
import { AuthContext } from '../context/auth';
import ApiResponse from '../model/ApiResponse';
import HelpLink from '../model/HelpLink';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  avatar: {
    backgroundColor: theme.palette.success.main,
  },
  videoIframe: {
    display: 'block',
    margin: '0 auto',
    marginBottom: theme.spacing(1),
    width: '100%',
    height: '40vw',
  },
}));

type Props = {
  provider: string,
};

const HelpLinks = (props: Props) => {
  const { doGet } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const { t } = useTranslation();
  const { provider } = props;

  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState<number>(0);
  const [links, setLinks] = useState([]);
  const [hasMore, setHasMore] = useState<boolean>(false);

  const loadLinks = () => {
    let providerQuery = '';
    if (!!provider) {
      providerQuery = `provider=${provider}&`;
    }
    setLoading(true);
    doGet(`/customer/help-links?${providerQuery}page=${page}`)
      .then((response: ApiResponse) => {
        if (response.ok && response.data) {
          const list = HelpLink.parseList(response.data.list);
          setHasMore(!!response.data ? !!response.data.hasMore : false);
          setLinks(links.concat(list));
          setPage(page + 1);
        } else if (!response.is401Error()) {
          enqueueSnackbar(t(response.message), {
            variant: 'error',
          });
        }
        setLoading(false);
      });
  };

  const loadAll = () => {
    setLinks([]);
    setPage(0);
    loadLinks();
  };

  useEffect(loadAll, []);

  return (
    <Layout activeKey={routes.links}>
      {loading && [1, 2, 3, 4, 5].map((index) => (
        <Skeleton key={index}/>
      ))}
      {(!links.length && !loading) && <IconButton aria-label="reload" onClick={loadAll}>
        <RefreshIcon/>
      </IconButton>}
      <Grid container spacing={1}>
        {links.map((link: HelpLink) => (
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Card className={classes.root}>
              <CardHeader
                avatar={
                  <Avatar aria-label="link-type" className={classes.avatar}>
                    {link.isVideo ? <VideoIcon/> : <LinkIcon/>}
                  </Avatar>
                }
                title={link.title}
                subheader={link.description}
              />
              <CardContent>
                {link.isVideo && <iframe title={link.title}
                  src={link.url}
                  className={classes.videoIframe}/>}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      {hasMore && <div style={{ textAlign: "center" }}><IconButton aria-label="load more" onClick={loadLinks}>
        <RefreshIcon/>
      </IconButton></div>}
    </Layout>
  );
};

export default HelpLinks;
